export default {
    methods: {
        isAdmin() {
            return this.$store.state.user.identity.roles.includes('ROLE_ADMIN');
        },
        isTrader() {
            return this.$store.state.user.identity.roles.includes('ROLE_TRADER');
        },
        isEditor() {
            return this.$store.state.user.identity.roles.includes('ROLE_EDITOR');
        },
        isCallCenter() {
            return this.$store.state.user.identity.roles.includes('ROLE_CALL_CENTER');
        },
        isCallCenterOnly() {
            return this.isCallCenter() && !this.isAdmin();
        },
        isTraderOnly() {
            return this.isTrader() && !this.isAdmin();
        },
        isEditorOnly() {
            return this.isEditor() && !this.isAdmin();
        },
    },
    computed: {
        callCenter() {
            return this.isCallCenter();
        },
        callCenterOnly() {
            return this.isCallCenterOnly();
        }
    },
}